import React from "react";
import { Logo } from "../../Components/Logo/Logo";

export const Drawer = (props) => {
  const { visible, navlinksrow, setVisible } = props;
  return (
    <div
      id="mobile-drawer"
      role="dialog"
      aria-label="Navigation menu"
      aria-modal="true"
      aria-hidden={!visible}
      className={`${visible ? "activedrawer" : ""} drawer`}
    >
      <button
        aria-label="Close navigation menu"
        className="drawer-close"
        onClick={() => setVisible(false)}
      >
        <i className="fal fa-times" aria-hidden="true"></i>
      </button>
      <Logo />
      <nav aria-label="Mobile navigation">
        <div className="drawerlinks">{navlinksrow}</div>
      </nav>
    </div>
  );
};
